/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
import { call, put, takeEvery, select } from "redux-saga/effects";
import moment from "moment";
import { getRequest, exportXlsxRequest } from "../../helpers/Api";
import { types } from "../reducers/punches";
import { userNotAuthorizedHandler } from "./authentication";

/**
 * Fetch punches when filters are changed
 */
function* fetchPunchesRequest({ payload }) {
  yield put({ type: types.SET_LOADING, payload: { loading: true } });
  const {
    page: prevPage,
    perPage: prevPerPage,
    qs: prevQs,
  } = yield select((state) => state.punches);
  const params = new URLSearchParams();
  params.append("perPage", prevPerPage || "20");
  params.append("page", prevPage || "0");
  params.append("qs", prevQs || "");
  params.append("type", payload.type || "employee");
  if (payload.dateRange && Array.isArray(payload.dateRange) && payload.dateRange.length === 2) {
    params.append("start", moment(payload.dateRange[0]).format("YYYY-MM-DD"));
    params.append("end", moment(payload.dateRange[1]).format("YYYY-MM-DD"));
  }
  if (payload.punchesFrom && payload.punchesFrom !== "all") {
    params.append("device", payload.punchesFrom);
  }
  console.log(payload);

  const response = yield call(getRequest, {
    url: `/punches?${params.toString()}`,
    authorized: true,
  });

  if (response.status === 401) {
    yield call(userNotAuthorizedHandler);
    return;
  }

  if (response.status === 200) {
    const punches = response.result;
    yield put({ type: types.ADD_PUNCHES, payload: { punches } });
    yield put({
      type: types.SET_PUNCHES_TOTAL_ITEMS,
      payload: {
        totalItems: response.totalItems,
      },
    });
  } else {
    payload.onFailure(response.message || "Internal server error");
  }
  yield put({ type: types.SET_LOADING, payload: { loading: false } });
}
function* exportPunchesRequest({ payload }) {
  yield put({ type: types.SET_LOADING, payload: { loading: true } });
  const {
    page: prevPage,
    perPage: prevPerPage,
    qs: prevQs,
  } = yield select((state) => state.punches);
  const params = new URLSearchParams();
  params.append("perPage", prevPerPage || "20");
  params.append("page", prevPage || "0");
  params.append("qs", prevQs || "");
  params.append("type", payload.type || "employee");
  if (payload.dateRange && Array.isArray(payload.dateRange) && payload.dateRange.length === 2) {
    params.append("start", moment(payload.dateRange[0]).format("YYYY-MM-DD"));
    params.append("end", moment(payload.dateRange[1]).format("YYYY-MM-DD"));
  }
  if (payload.punchesFrom && payload.punchesFrom !== "all") {
    params.append("device", payload.punchesFrom);
  }

  const response = yield call(exportXlsxRequest, {
    url: `/export/punches?${params.toString()}`,
    authorized: true,
  });

  yield put({ type: types.SET_LOADING, payload: { loading: false } });
  if (!response.status === 200) {
    payload.onFailure(response.message || "Internal server error");
  }
}

export default function* sagas() {
  yield takeEvery(types.FETCH_PUNCHES_REQUEST, fetchPunchesRequest);
  yield takeEvery(types.EXPORT_PUNCHES_REQUEST, exportPunchesRequest);
}
